import { Box, ScrollArea } from '@workos-inc/design-system';
export const SideNav = ({
  children
}: React.PropsWithChildren) => <div className="SideNav" data-sentry-component="SideNav" data-sentry-source-file="side-nav.tsx">
    <div className="SideNavInner">
      <ScrollArea.Root data-sentry-element="ScrollArea.Root" data-sentry-source-file="side-nav.tsx">
        <ScrollArea.Viewport className="SideNavScroll" data-sentry-element="ScrollArea.Viewport" data-sentry-source-file="side-nav.tsx">
          <Box pl="6" pr="5" py="4" data-sentry-element="Box" data-sentry-source-file="side-nav.tsx">
            {children}
          </Box>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar my="4" orientation="vertical" data-sentry-element="ScrollArea.Scrollbar" data-sentry-source-file="side-nav.tsx" />
      </ScrollArea.Root>
    </div>
  </div>;